import { render, staticRenderFns } from "./transferSearch.vue?vue&type=template&id=2bf98360&"
import script from "./transferSearch.vue?vue&type=script&lang=js&"
export * from "./transferSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports